import styled, { keyframes } from 'styled-components';

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 8px 0;
`;

export const StatusIcon = styled.div`
  font-size: 48px;
  line-height: 1;
`;

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const Spinner = styled.div`
  width: 48px;
  height: 48px;
  border: 3px solid rgba(155, 89, 182, 0.2);
  border-top-color: rgba(155, 89, 182, 0.8);
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

export const Title = styled.div`
  font-family: 'Share Tech Mono', monospace;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 1px;
  color: rgba(255, 255, 255, 0.9);
  text-transform: uppercase;
  text-align: center;
`;

export const StatusText = styled.div<{ $status: 'pending' | 'success' | 'error' }>`
  font-family: 'Share Tech Mono', monospace;
  font-size: 12px;
  text-align: center;
  color: ${({ $status }) => {
    switch ($status) {
      case 'success':
        return 'rgba(46, 204, 113, 0.9)';
      case 'error':
        return 'rgba(231, 76, 60, 0.9)';
      default:
        return 'rgba(255, 255, 255, 0.6)';
    }
  }};
`;

export const CloseButton = styled.button`
  width: 100%;
  padding: 12px;
  margin-top: 8px;
  background: linear-gradient(135deg, rgba(155, 89, 182, 0.7), rgba(52, 152, 219, 0.7));
  border: none;
  border-radius: 10px;
  color: #fff;
  font-family: 'Share Tech Mono', monospace;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 2px;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background: linear-gradient(135deg, rgba(155, 89, 182, 0.8), rgba(52, 152, 219, 0.8));
    box-shadow:
      0 0 30px rgba(155, 89, 182, 0.5),
      0 0 60px rgba(52, 152, 219, 0.3);
  }
`;
